import React from 'react';

export default ({ title, width }) => {
    const src = require(`assets/icons/userTitle/${title ? title : 'beginner'}_badge.svg`);

    return <img src={src} style={{ height: width }} alt="" />;
};
